import { useEffect, useState } from 'react';

const primaryMobileLinks = [
  'Shop',
  'New In',
  'Sale',
  'Food, Drinks & Accessories',
  'Hot',
  'Coming Soon',
  'Delivery Information',
  'News',
  'Modern Slavery Statement',
  'Privacy Policy',
  'Terms & Conditions',
  'Contact Us',
  'Careers',
];

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!menuOpen) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [menuOpen]);

  return (
    <header className="site-header">
      <div className="top-strip">
        <div className="top-strip__left">sales@vapesupplier.co.uk | 0121 663 1339</div>
        <div className="top-strip__right">
          <a href="#trade-login">Trade Login</a>
          <span>|</span>
          <a href="#trade-register">Trade Register</a>
          <span>|</span>
          <a href="#help">Help</a>
          <span>|</span>
          <a href="#contact">Contact</a>
        </div>
      </div>

      <nav className="main-nav">
        <div className="brand">
          <div className="brand__title">VAPE</div>
          <div className="brand__sub">SUPPLIER</div>
        </div>

        <button
          type="button"
          className="menu-toggle"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
        >
          {menuOpen ? (
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <line x1="5" y1="5" x2="19" y2="19" />
              <line x1="19" y1="5" x2="5" y2="19" />
            </svg>
          ) : (
            <>
              <span />
              <span />
              <span />
            </>
          )}
        </button>

        <button type="button" className="search-btn search-btn--mobile" aria-label="Search products">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="11" cy="11" r="7" />
            <line x1="16.65" y1="16.65" x2="21" y2="21" />
          </svg>
          <span>Search</span>
        </button>

        <ul className={`main-links ${menuOpen ? 'main-links--open' : ''}`}>
          <li><a href="#shop">Shop</a></li>
          <li><a className="tag-link tag-link--new" href="#new">New</a></li>
          <li><a className="tag-link tag-link--sale" href="#sale">Sale</a></li>
          <li><a href="#food">Food, Drinks & Accessories</a></li>
          <li><a href="#soon">Soon</a></li>
          <li><a href="#news">Vape News</a></li>
        </ul>

        <div className="actions">
          <button type="button" className="search-btn search-btn--desktop" aria-label="Search products">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="11" cy="11" r="7" />
              <line x1="16.65" y1="16.65" x2="21" y2="21" />
            </svg>
            <span>Search</span>
          </button>
          <button type="button" className="account-btn" aria-label="Account">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <circle cx="12" cy="9.1" r="3.1" />
              <path d="M7 17.2c1.1-2.2 2.9-3.3 5-3.3s3.9 1.1 5 3.3" />
            </svg>
          </button>
          <button type="button" className="cart-btn" aria-label="Cart">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6 7h12l-1 13H7L6 7z" />
              <path d="M9 7a3 3 0 0 1 6 0" />
            </svg>
          </button>
        </div>
      </nav>

      <div className={`mobile-drawer ${menuOpen ? 'mobile-drawer--open' : ''}`}>
        <div className="mobile-drawer__top">
          <button type="button" className="mobile-drawer__close" onClick={() => setMenuOpen(false)} aria-label="Close menu">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <line x1="5" y1="5" x2="19" y2="19" />
              <line x1="19" y1="5" x2="5" y2="19" />
            </svg>
          </button>
          <div className="mobile-drawer__login">
            <a href="#login-register">Login / Register</a>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <circle cx="12" cy="9.1" r="3.1" />
              <path d="M7 17.2c1.1-2.2 2.9-3.3 5-3.3s3.9 1.1 5 3.3" />
            </svg>
          </div>
        </div>

        <ul className="mobile-drawer__links">
          {primaryMobileLinks.map((link) => (
            <li key={link}>
              <a href="/" onClick={(event) => event.preventDefault()}>
                {link}
              </a>
            </li>
          ))}
        </ul>

        <div className="mobile-drawer__extra">
          <a href="/" onClick={(event) => event.preventDefault()}>
            Contact
          </a>
          <a href="/" onClick={(event) => event.preventDefault()}>
            Login
          </a>
        </div>
      </div>

      <div className="info-strip">
        <div className="info-strip__item">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M1 4h11v9H1z" />
            <path d="M12 7h4l4 4v2h-8z" />
            <circle cx="6" cy="17" r="2" />
            <circle cx="17" cy="17" r="2" />
            <path d="M20 7h3" />
            <path d="M20 10h3" />
          </svg>
          <span>Fast Delivery* Orders over £150+VAT</span>
        </div>
        <div className="info-strip__item">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M1 4h11v9H1z" />
            <path d="M12 7h4l4 4v2h-8z" />
            <circle cx="6" cy="17" r="2" />
            <circle cx="17" cy="17" r="2" />
            <circle cx="3" cy="7" r="1" />
          </svg>
          <span>Same Day Dispatch* Order before 5pm</span>
        </div>
        <div className="info-strip__item">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <rect x="4" y="5" width="16" height="16" rx="2" />
            <path d="M8 3v4" />
            <path d="M16 3v4" />
            <path d="M8 12h8" />
          </svg>
          <span>Order by 1pm Friday for Saturday delivery</span>
        </div>
        <div className="info-strip__item">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="8" r="3.2" />
            <path d="M4.5 21c1.2-3.7 3.8-5.4 7.5-5.4s6.3 1.7 7.5 5.4" />
          </svg>
          <span>Contact your account manager for further assistance</span>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
